var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"uk-visible@l uk-height-1-1 main-container"},[_c('div',{staticClass:"uk-flex uk-margin-remove-left uk-height-1-1"},[_c('DesktopContent',{staticClass:"main-content"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }